// Action Types
export const CACHE_VEHICLE_MAKES = 'CACHE_VEHICLE_MAKES';
export const CACHE_VEHICLE_YEARS = 'CACHE_VEHICLE_YEARS';
export const CACHE_VEHICLE_MODELS = 'CACHE_VEHICLE_MODELS';
export const CACHE_VEHICLE_TRIMS = 'CACHE_VEHICLE_TRIMS';
export const CACHE_VEHICLE_PRICES = 'CACHE_VEHICLE_PRICES';
export const CLEAR_VEHICLE_CACHE = 'CLEAR_VEHICLE_CACHE';

// Initial State Structure
const initialState = {
  makes: {},
  years: {},
  models: {},
  trims: {},
  prices: {},
};

const createCacheEntry = (action) => ({
  data: action.data,
  timestamp: action.timestamp,
  ttl: action.ttl,
});

const updateCacheSection = (state, sectionName, action) => ({
  ...state,
  [sectionName]: {
    ...state[sectionName],
    [action.cacheKey]: createCacheEntry(action),
  },
});

const vehicleCacheReducer = (state = initialState, action) => {
  switch (action.type) {
    case CACHE_VEHICLE_MAKES:
      return updateCacheSection(state, 'makes', action);
    case CACHE_VEHICLE_YEARS:
      return updateCacheSection(state, 'years', action);
    case CACHE_VEHICLE_MODELS:
      return updateCacheSection(state, 'models', action);
    case CACHE_VEHICLE_TRIMS:
      return updateCacheSection(state, 'trims', action);
    case CACHE_VEHICLE_PRICES:
      return updateCacheSection(state, 'prices', action);
    case CLEAR_VEHICLE_CACHE:
      return initialState;
    default:
      return state;
  }
};

export default vehicleCacheReducer;
